import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() || '';

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

/** main.tsx env kontrolünden sonra yüklenir; yine de güvenli varsayılan */
export const supabase: SupabaseClient = supabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createClient('https://placeholder.invalid', 'placeholder', {
      auth: { persistSession: false, autoRefreshToken: false },
    });